// extracted by mini-css-extract-plugin
export default {"scoreContainer":"NumberScoreComponent_scoreContainer__1rHWL","header":"NumberScoreComponent_header__cEbbH","options":"NumberScoreComponent_options__CAi-v"};